var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-card',{staticClass:"action-card",attrs:{"elevation":hover ? 6 : 2}},[_c('v-card-text',[_vm._t("default")],2)],1)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }